export default __webpack_public_path__ + "static/media/TwitterBlack.33fa47d0.svg";